export function createMapStore(store) {
    let storeValue = new Map();
    store.subscribe((v) => (storeValue = v));
    return {
        subscribe: (subscriber, invalidate) => store.subscribe(subscriber, invalidate),
        get: (key) => storeValue.get(key),
        has: (key) => storeValue.has(key),
        size: () => storeValue.size,
        set: store.set,
        insert: (key, value) => {
            store.update((map) => {
                map.set(key, value);
                return map;
            });
        },
        update: (updater) => {
            store.update(updater);
        },
        delete: (key) => {
            if (storeValue.has(key)) {
                store.update((map) => {
                    map.delete(key);
                    return map;
                });
                return true;
            }
            return false;
        },
        clear: () => store.update((map) => {
            map.clear();
            return map;
        }),
    };
}
